import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { connect, } from 'react-redux';
import { pipe, } from 'ramda';
import { useLocation, useHistory, } from 'react-router-dom';

import { Loader, } from 'common/components/Loader';
import { StoreBasicDataApiStructure, } from 'common/types';
import { BookstoreClosed, Auth, LastSessionCartInfoDialog, } from './components';
import { ROOT_ROUTE, } from 'common/constants';
import { repositories, } from 'api';
import { infoOperations, } from 'store/ducks/info';
import { meOperations, } from 'store/ducks/me';
import { shopCartOperations, } from 'store/ducks/shopCart';
import { ShopCartItem } from 'store/ducks/shopCart/types';

type Props = StoreBasicDataApiStructure<repositories.InfoType> & {
    isClosed: boolean | undefined | null,
    fetchInfo: Function,
    fetchMe: Function,
    fetchCart: Function,
    areItemsExistAtShopFromLastSession: boolean,
};

const forbiddenRoutesForInfoModal = [ 'checkout', 'login', 'access-information', ];
let redirectionPath = '';

const Home: React.FC<Props> = ({
    isClosed,
    isLoading,
    data,
    fetchInfo,
    fetchMe,
    fetchCart,
    areItemsExistAtShopFromLastSession,
}) => {
    const location = useLocation();
    const history = useHistory();
    const [ openModal, setModalStatus ] = useState(false);

    if (!location.pathname.includes('login')) {
        redirectionPath = location.pathname;
    }

    const isRestrictedRoute = useMemo(
        () => forbiddenRoutesForInfoModal.some(route => location.pathname.includes(route)),
        [ location.pathname, ]
    );

    useEffect(() => {
        if (areItemsExistAtShopFromLastSession) {
            setModalStatus(areItemsExistAtShopFromLastSession);
            return;
        }
    }, [ areItemsExistAtShopFromLastSession, ]);

    useEffect(() => {
        fetchInfo();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (isClosed === null) {
            fetchMe();
            fetchCart();
        }
    }, [ isClosed, ]);

    useEffect(() => {
        if (location.pathname !== ROOT_ROUTE && isClosed) {
            history.push(ROOT_ROUTE);
            return;
        }
    }, [
        location.pathname,
        history.push,
        isClosed,
    ]);

    const handleClose = useCallback(
        () => setModalStatus(false),
        []
    );

    return (
        <>
            <Loader isLoading={isLoading}>
                {isClosed
                    ? (<BookstoreClosed message={data?.maintenance?.message} />)
                    : (<Auth redirectionPath={redirectionPath} />)}
            </Loader>
            <LastSessionCartInfoDialog open={!isRestrictedRoute && openModal}
                                       handleClose={handleClose} />
        </>
    );
};

type MappingType = {
    info: StoreBasicDataApiStructure<repositories.InfoType>,
    shopCart: Array<ShopCartItem>,
    me: StoreBasicDataApiStructure<repositories.MeType>,
};

const mapStateToProps = ({ info, shopCart, me, }: MappingType) => {
    const isShopExist = Boolean(shopCart.length);
    const wasTheCartCreated = Boolean(me.data?.carts?.find(cart => cart.channel === info.data?.code)?.token);

    return {
        ...info,
        // TODO PB Consider how to refactor this prop, bookstore should have two state. Maybe compose api calling in other place.
        isClosed: info.data?.maintenance,
        areItemsExistAtShopFromLastSession: isShopExist && wasTheCartCreated,
    };
};

const mapDispatchToProps = {
    fetchInfo: infoOperations.request,
    fetchMe: meOperations.request,
    fetchCart: shopCartOperations.fetchCart.request
};

export default pipe<any, any>(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
)(Home);
